var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-balance-summary-loader"},[_c('BaseText',{attrs:{"size":"sm"}},[_vm._v("Patrimônio total")]),_c('SkeletonLoader',[_c('div',{staticClass:"home-balance-summary-loader__total"}),_c('div',{staticClass:"home-balance-summary-loader__total-subtitle"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }